import { closePopupOnClickOutside, disableScroll, enableScroll } from '../functions/helpers';

const openButtonSelector = '.menu-toggle';
const toggleButton = document.querySelector( openButtonSelector );
const siteNavigationContainer = document.querySelector( '#site-navigation' );

const getIsActive = () => siteNavigationContainer?.classList.contains( 'active' );

const openMobileMenu = () => {
	disableScroll();
	siteNavigationContainer?.classList.add( 'active' );
	toggleButton?.classList.add( 'active' );
};

export const closeMobileMenu = () => {
	siteNavigationContainer?.classList.remove( 'active' );
	toggleButton?.classList.remove( 'active' );
	enableScroll();
};

export const toggleMobileMenu = () => {
	const isActive = getIsActive();

	if ( isActive ) {
		closeMobileMenu();
	} else {
		openMobileMenu();
	}
};

export const closeMobileMenuOnClickOutside = event => {
	return closePopupOnClickOutside( {
		event,
		isActive: getIsActive(),
		openButtonSelector,
		sidebarContainerSelector: '#site-navigation > .menu',
		callback: closeMobileMenu,
	} );
};

export const closeMobileMenuOnResize = event => {
	if ( !siteNavigationContainer ) return event;
	if ( !getIsActive() ) return event;

	const _window = jQuery( event.currentTarget );
	if ( _window.width() > 991 ) {
		closeMobileMenu();
	}
};
